import { queryOptions } from "@tanstack/react-query";

import { fetchCart } from "../Cart/requests";
import { fetchCheckoutSession } from "./request";

export const CheckoutSessionQueries = {
  byUuid: (uuid: string) =>
    queryOptions({
      queryKey: ["checkout_session", { uuid }],
      queryFn: () => fetchCheckoutSession(uuid),
    }),
  completeCartByCheckoutSession: (uuid: string) =>
    queryOptions({
      queryKey: [
        CheckoutSessionQueries.byUuid(uuid).queryKey,
        "completed_cart",
      ],
      queryFn: async () => {
        const session = await fetchCheckoutSession(uuid);
        if (session.originatorType !== "OrderCart::Cart") {
          throw new Error("Checkout session is not for a cart");
        }
        const completedCart = await fetchCart(session.originatorId);
        return completedCart;
      },
    }),
};
